import React, { forwardRef } from 'react';
import { motion } from 'framer-motion';
import { SnackbarContent } from 'notistack';

interface AnimatedSnackbarProps {
  id?: string | number;
  message?: React.ReactNode;
  variant?: 'default' | 'success' | 'error' | 'warning' | 'info';
}

const AnimatedSnackbar = forwardRef<HTMLDivElement, AnimatedSnackbarProps>((props, ref) => {
  const { id, message, variant = 'default' } = props;

  const getVariantStyles = () => {
    switch (variant) {
      case 'success':
        return {
          backgroundColor: '#4caf50',
          color: 'white',
        };
      case 'error':
        return {
          backgroundColor: '#f44336',
          color: 'white',
        };
      case 'warning':
        return {
          backgroundColor: '#ff9800',
          color: 'white',
        };
      case 'info':
        return {
          backgroundColor: '#2196f3',
          color: 'white',
        };
      default:
        return {
          backgroundColor: '#323232',
          color: 'white',
        };
    }
  };

  return (
    <motion.div
      ref={ref}
      initial={{ 
        y: 50, 
        opacity: 0,
        scale: 0.95
      }}
      animate={{ 
        y: 0, 
        opacity: 1,
        scale: 1
      }}
      exit={{ 
        y: 30, 
        opacity: 0,
        scale: 0.95
      }}
      transition={{
        type: "spring",
        stiffness: 300,
        damping: 30,
        duration: 0.3
      }}
      style={{
        ...getVariantStyles(),
        padding: '12px 16px',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: 500,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '288px',
        maxWidth: '568px',
        margin: '4px 0',
      }}
    >
      {message}
    </motion.div>
  );
});

AnimatedSnackbar.displayName = 'AnimatedSnackbar';

export default AnimatedSnackbar;